import React, { MutableRefObject } from 'react';
import { AxiosInstance } from 'axios';
import { useAxios } from '../hooks/useAxios';

const axios: any = undefined;

const AxiosInstanceContext = React.createContext<MutableRefObject<AxiosInstance | undefined>>(axios);
AxiosInstanceContext.displayName = 'AxiosInstanceContext';

export const AxiosInstanceProvider = ({ token, children }: { token: string, children: React.ReactElement}): React.ReactElement => {
  const axiosInstance: MutableRefObject<AxiosInstance | undefined> = useAxios(token);

  return (
    <AxiosInstanceContext.Provider value={ axiosInstance }>
      { children }
    </AxiosInstanceContext.Provider>
  );
};

export const useAxiosInstance = () => {
  return React.useContext(AxiosInstanceContext);
};